import { C as Component } from "./component-CZdU8SYg.js";
import { d as defineCustomElement } from "./utilities-D68o91ht.js";
class DropdownMenuComponent extends Component {
  /** @type {ResizeObserver | null} */
  #resizeObserver = null;
  connectedCallback() {
    super.connectedCallback();
    const mode = this.getAttribute("data-menu-mode");
    if (mode === "click") {
      this.dropdowns = this.querySelectorAll("[data-dropdown]");
      this.initClickMode();
    }
    this.positionMegaMenus();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.#resizeObserver) {
      this.#resizeObserver.disconnect();
      this.#resizeObserver = null;
    }
  }
  /**
   * Position fixed mega menus below the header
   * Calculates header height and sets top position for fixed mega menus
   */
  positionMegaMenus() {
    const megaMenus = this.querySelectorAll(".dropdown-menu.fixed");
    if (megaMenus.length === 0) {
      return;
    }
    const updatePosition = () => {
      const headerSection =
        document.querySelector('section[class*="header"]') ||
        document.querySelector("#shopify-section-header");
      if (!headerSection) {
        return;
      }
      const headerBar = headerSection.querySelector(".container > div.flex");
      if (!headerBar) {
        return;
      }
      const headerBarRect = headerBar.getBoundingClientRect();
      const headerBarTop = headerBarRect.top;
      const headerBarHeight = headerBar.offsetHeight;
      const headerBottom = headerBarTop + headerBarHeight;
      megaMenus.forEach((menu) => {
        menu.style.top = `${headerBottom}px`;
      });
    };
    updatePosition();
    window.addEventListener("resize", updatePosition, { signal: this.signal });
    this.#resizeObserver = new ResizeObserver(updatePosition);
    const headerSectionForObserver =
      document.querySelector('section[class*="header"]') ||
      document.querySelector("#shopify-section-header");
    if (headerSectionForObserver) {
      this.#resizeObserver.observe(headerSectionForObserver);
    }
  }
  initClickMode() {
    this.dropdowns.forEach((dropdown) => {
      const toggle = dropdown.querySelector(".dropdown-toggle");
      if (!toggle) {
        return;
      }
      toggle.addEventListener(
        "click",
        (e) => {
          e.preventDefault();
          e.stopPropagation();
          const siblings = dropdown.parentElement.querySelectorAll("[data-dropdown]");
          siblings.forEach((sibling) => {
            if (sibling !== dropdown) {
              sibling.classList.remove("is-open");
            }
          });
          dropdown.classList.toggle("is-open");
        },
        { signal: this.signal }
      );
    });
    document.addEventListener(
      "click",
      (e) => {
        if (!e.target.closest("[data-dropdown]")) {
          this.closeAllDropdowns();
        }
      },
      { signal: this.signal }
    );
  }
  /**
   * Close all dropdowns in this menu component
   */
  closeAllDropdowns() {
    const allDropdowns = this.querySelectorAll("[data-dropdown]");
    allDropdowns.forEach((dropdown) => {
      dropdown.classList.remove("is-open");
    });
  }
}
defineCustomElement("dropdown-menu-component", DropdownMenuComponent);
